import { useCallback, useEffect, useState } from "react";
import { ControllerProcedimientosPrecios } from "../../Service/Service.porcedimientos";
import { Badge, Col, Modal, Row } from "react-bootstrap";
import { Input, Table } from "antd";
import useConfirm from "../../hook/useConfirm";
import { ProcedimientosNuevosBilling } from "../../Service/Service.billing";
import { useDispatch } from "react-redux";
import { agregarProcedimientos } from "../../redux/actions";
import Swal from "sweetalert2";

function ProcedimientosNuevosFactura({ data }) {

    const { show, handleClose, pacienteSeleccionado,pacienteSelectedDetails } = data;

    //const tipoSeguro = pacienteSelectedDetails.tipo_seguro;

    //alert(JSON.stringify(pacienteSelectedDetails.tipo_seguro));
    const dispatch = useDispatch();

    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [filteredProcedimientos, setFilteredProcedimientos] = useState([]);    
    const [procedimientosList, setprocedimientosList] = useState([]);
    const [selectedProcedimientos, setSelectedProcedimientos] = useState([]);

    const columns = [
        {
            title: 'Código',
            dataIndex: ['ExamenTipo', 'codigo'],
            key: 'ExamenTipo.codigo',
            width: 50,
        },
        {
            title: 'Descripción',
            dataIndex: ['ExamenTipo', 'descripcion'],
            key: 'ExamenTipo.descripcion',
            width: 300,
            render: (_, record) => (
                <>
                    {record.ExamenTipo.descripcion} {" "}
                    {
                        record.ExamenTipo.contifico_id && (
                            <Badge bg="success">{"En contífico"}</Badge>
                        )
                    }
                </>
            ),
        },
        {
            title: 'Seguro/Entidad',
            dataIndex: ['Seguros', 'razon_social'],
            key: 'Seguros.razon_social',
            width: 40,
        },        
        {
            title: 'Precio',
            dataIndex: 'precio',
            key: 'precio',
            width: 80,
            align: 'right',
            render: (_, record) => (
                <>
                    {record.precio.toFixed(2)}
                </>
            ),             
        }     
    ];   

    const onRowSelectionChangeNuevo = (selectedRowKeys, selectedRows) => {
        setSelectedProcedimientos(selectedRows);
    };    
    
    const rowSelectionNuevo = {
        onChange: onRowSelectionChangeNuevo
    };

    const handleAgregarProcedimientos = async () => {

        setLoading(true);
        try {

            const data = {
                paciente_id: pacienteSeleccionado.value,
                procedures: selectedProcedimientos.map( ex => ({
                    examen_tipo_id: ex.idExamenTipo,
                    precio: ex.precio,
                    seguro_id: ex.seguro_id
                }))
            }
            const response = await ProcedimientosNuevosBilling(data);
            if (!response.success) {
                throw new Error(response.message || "Error al agregar procedimientos");
            }

            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                timer: 1500,
                showConfirmButton: false,
            });
            dispatch(agregarProcedimientos(response.data));

            handleClose();
            
        } catch (response) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: response.message || "Hubo un error al agregar el procedimiento",
            });

        } finally {
            setLoading(false);
        }
    };

    const fetchInitialData = useCallback(async () => {
        if (pacienteSeleccionado) {
          setLoading(true);
      
          const result = await ControllerProcedimientosPrecios();
      
          if (result && result.success) {
            const idSeguro = pacienteSeleccionado.seguros?.idseguro; // ✅ Aquí accedes directamente
            //alert(JSON.stringify(idSeguro));
            const fetchedProcedimientos = result.data
              .filter(item => item.seguro_id === idSeguro)
              .map((item, index) => ({
                ...item,
                key: item.idprocedimiento_company_precios,
                index,
              }));
      
            setprocedimientosList(fetchedProcedimientos);
            setFilteredProcedimientos(fetchedProcedimientos);
          }
      
          setLoading(false);
        }
      }, [pacienteSeleccionado]);
      
    /*const fetchInitialData = useCallback(async () => {
        if (pacienteSeleccionado) {
            setLoading(true);
            const result = await ControllerProcedimientosPrecios();
    
            if (result && result.success) {

                const fetchedProcedimientos = result.data.map((item, index) => ({
                    ...item,
                    key: item.idprocedimiento_company_precios,
                    index
                }))
                setprocedimientosList(fetchedProcedimientos);
                setFilteredProcedimientos(fetchedProcedimientos);
            }

            setLoading(false);
        }

    }, [pacienteSeleccionado]);*/

    useEffect(() => {
        if (show) {
            fetchInitialData();
        }
    }, [show, fetchInitialData]);

    useEffect(() => {
        
        if (searchTerm.trim() === "") {
            setFilteredProcedimientos(procedimientosList);
        } else {
            const filteredData = procedimientosList.filter(item =>
                item.ExamenTipo?.codigo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.ExamenTipo?.descripcion?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredProcedimientos(filteredData);
        }
    }, [searchTerm, procedimientosList]);    

    return (
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Agregar nuevo Procedimiento</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <Input
                                placeholder="Buscar por código o descripción"
                                className="me-2 flex-grow-1"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-primary mx-1 text-nowrap"
                                disabled={selectedProcedimientos.length <= 0}
                                onClick={handleAgregarProcedimientos}
                            >Agregar
                            </button>
                        </div>
                    </Col>

                </Row>

                <Row>
                    <Col>
                        <Table loading={loading} 
                            columns={columns} 
                            size='small' 
                            scroll={{ x: "max-content", y: 300 }}
                            pagination={true}
                            rowSelection={rowSelectionNuevo}
                            dataSource={filteredProcedimientos}
                        />
                    </Col>
                </Row>

            </Modal.Body>

        </Modal>
    )
}

export default ProcedimientosNuevosFactura